(() => {
  if (customElements.get('goose-detail-gallery')) return;
  customElements.define('goose-detail-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.dialog = this.querySelector('dialog');
      this.photos = [...this.querySelectorAll('[data-detail-photo]')];
      if (!this.dialog || !this.photos.length) return;
      this.events = new AbortController();
      this.imageCache = new Map();
      const options = { signal: this.events.signal };
      const prepare = event => {
        const photo = event.target.closest('[data-detail-photo]');
        if (photo && this.contains(photo)) this.preparePhoto(photo);
      };
      this.addEventListener('pointerover', prepare, options);
      this.addEventListener('pointerdown', prepare, options);
      this.addEventListener('focusin', prepare, options);
      this.addEventListener('click', event => {
        const photo = event.target.closest('[data-detail-photo]');
        if (photo && this.contains(photo)) {
          this.opener = photo;
          this.previousOverflow = document.body.style.overflow;
          this.scrollLocked = true;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.showPhoto(this.photos.indexOf(photo));
        } else if (event.target.closest('[data-detail-close]')) this.closeViewer();
        else if (event.target.closest('[data-detail-previous]')) this.showPhoto(this.index - 1);
        else if (event.target.closest('[data-detail-next]')) this.showPhoto(this.index + 1);
        else if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeViewer();
        }
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.closeViewer();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open && this.scrollLocked) this.finishClose();
      }, options);
    }
    closeViewer() {
      this.dialog.close();
      this.finishClose();
    }
    finishClose() {
      this.photoRequest = (this.photoRequest || 0) + 1;
      this.dialog.removeAttribute('aria-busy');
      this.unlock();
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
    }
    showPhoto(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      const image = this.dialog.querySelector('img');
      const request = this.photoRequest = (this.photoRequest || 0) + 1;
      image.width = Number(photo.dataset.photoWidth);
      image.height = Number(photo.dataset.photoHeight);
      const thumbnail = photo.querySelector('img');
      image.src = thumbnail.currentSrc || thumbnail.src;
      image.alt = photo.dataset.photoTitle;
      this.dialog.querySelector('[data-detail-title]').textContent = photo.dataset.photoTitle;
      const caption = this.dialog.querySelector('[data-detail-caption]');
      caption.textContent = photo.dataset.photoCaption;
      caption.hidden = !photo.dataset.photoCaption;
      this.dialog.querySelector('[data-detail-counter]').textContent = (this.index + 1) + ' / ' + this.photos.length;
      this.dialog.setAttribute('aria-busy', 'true');
      this.preparePhoto(photo).then(loaded => {
        if (request !== this.photoRequest) return;
        if (loaded) image.src = loaded.src;
        this.dialog.removeAttribute('aria-busy');
      });
    }
    photoUrl(photo) {
      const ratio = Number(photo.dataset.photoWidth) / Number(photo.dataset.photoHeight);
      const mobile = window.innerWidth < 750;
      const visibleWidth = Math.min(800, window.innerWidth - (mobile ? 68 : 88), Math.max(1, window.innerHeight - 230) * ratio);
      const neededWidth = visibleWidth * Math.min(window.devicePixelRatio || 1, 2);
      const width = [640, 800, 1024, 1280, 1600].find(size => size >= neededWidth) || 1600;
      const url = new URL(photo.dataset.photoUrl, window.location.href);
      url.searchParams.set('width', Math.min(width, Number(photo.dataset.photoWidth)));
      return url.href;
    }
    preparePhoto(photo) {
      const url = this.photoUrl(photo);
      if (this.imageCache.has(url)) return this.imageCache.get(url);
      const pending = new Promise(resolve => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = async () => {
          try { await image.decode(); } catch {}
          resolve(image);
        };
        image.onerror = () => { this.imageCache.delete(url); resolve(null); };
        image.src = url;
      });
      this.imageCache.set(url, pending);
      return pending;
    }
    unlock() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = this.previousOverflow;
      this.scrollLocked = false;
    }
    disconnectedCallback() {
      this.photoRequest = (this.photoRequest || 0) + 1;
      this.unlock();
      if (this.dialog?.open) this.dialog.close();
      this.events?.abort();
      this.events = null;
    }
  });
})();
